export default {
  product: {
    marginRight: 15,
  },
  productWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
};
